
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/estaciones-abiertas",
      function () {
        return require("private-next-pages/[region]/estaciones-abiertas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/estaciones-abiertas"])
      });
    }
  